module.exports = __webpack_public_path__ + "img/home_news_1.bf7a2209.png";